import { EventEmitter } from 'events';
import assign from 'object-assign';
import AdminConstants from 'constants/AdminConstants';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import _ from 'underscore';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'COLUMN_STORE_UPDATE';
const ERROR_EVENT = 'COLUMN_CRUD_ERROR';

let error = {};
let mColumnsSet = {};

const ColumnsSetStore = assign({}, EventEmitter.prototype, {
  emitChange(payload) {
    this.emit(CHANGE_EVENT, payload);
  },
  emitError(payload) {
    this.emit(ERROR_EVENT, payload);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  removeErrorListener(callback) {
    this.removeListener(ERROR_EVENT, callback);
  },
  addErrorListener(callback) {
    this.on(ERROR_EVENT, callback);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  getColumnsSet() {
    return mColumnsSet;
  },
  updateColumnSet(data, del=false) {
    if (!del) {
      mColumnsSet.forEach((col, index) => {
        const { _id } = col;
        if (data._id === _id) {
          mColumnsSet[index] = data;
        }
      });
      return;
    }
    mColumnsSet = _.without(mColumnsSet, _.findWhere(mColumnsSet, {
      _id: data._id,
    }));
  },
  incColumnSet(data) {
    mColumnsSet.push(data);
  },
  setColumnSet(data) {
    mColumnsSet = data;
  },
  setError(e) {
    error = e;
  },
  getErrorMsg() {
    return error;
  },
});

ColumnsSetStore.dispatchToken = AdminAppDispatcher.register((payload) => {
  const action = payload.action;
  const { result } = action;

  switch (action.type) {
    case ActionTypes.CREATE_COLUMN_SET:
      ColumnsSetStore.incColumnSet(result);
      ColumnsSetStore.emitChange({ columns: ColumnsSetStore.getColumnsSet(), event: 'CREATE', result });
      break;
    case ActionTypes.DELETE_COLUMN_SET:
      ColumnsSetStore.updateColumnSet(result, true);
      ColumnsSetStore.emitChange({ columns: ColumnsSetStore.getColumnsSet(), event: 'DELETE', result });
      break;;
    case ActionTypes.UPDATE_COLUMN_SET:
      ColumnsSetStore.updateColumnSet(result);
      ColumnsSetStore.emitChange({ columns: ColumnsSetStore.getColumnsSet(), event: 'UPDATE', result });
      break;
    case ActionTypes.GET_COLUMN_SET:
      ColumnsSetStore.setColumnSet(result);
      ColumnsSetStore.emitChange({ columns: ColumnsSetStore.getColumnsSet(), event: 'GET', result});
      break;
    case ActionTypes.ERROR_COLUMN_SET:
      ColumnsSetStore.setError(result);
      ColumnsSetStore.emitError(ColumnsSetStore.getErrorMsg());
    default:
      break;
  }
});

export default ColumnsSetStore;
